import { AutogenModelCustomerFuelLookup, AutogenRowCustomerFuelLookup } from "./autogen/AutogenModelCustomerFuelLookup";

export class ModelCustomerFuelLookup extends AutogenModelCustomerFuelLookup<RowCustomerFuelLookup> {
	constructor() {
		super(RowCustomerFuelLookup);
	}
}

export class RowCustomerFuelLookup extends AutogenRowCustomerFuelLookup {
}